import $ from 'jquery';
import Api from '../util/Api';
import NewsItem from '../template/NewsItem';
import MainNewsItem from '../template/MainNewsItem';

const NewsService = {
    callback: {
        onchange: []
    },
    getItems(parameters) {
        return Api.get('/api/news/', parameters);
    },
    renderItems(items, append = false) {
        const html = items.map(item => NewsItem(item));
        const blogItemsDom = $('.news-items');
        if (append) {
            blogItemsDom.append(html);
        } else {
            blogItemsDom.html(html);
        }
    },
    renderMainItem(item) {
        const html = item ? MainNewsItem(item) : 'No news found in this section.';
        $('.main-news').html(html);
    },
};
export default NewsService;
